module.exports = __webpack_public_path__ + "static/media/MHeiHK-Medium.1fc6ffc3.svg";